export var adaptCoordinates = function adaptCoordinates(latitude, longitude) {
  if ([latitude, longitude].includes(null)) return;
  return {
    lat: latitude,
    lng: longitude
  };
};